import { styled, ToggleButton, toggleButtonClasses } from "@mui/material";

export const CategorySwitcherButton = styled(ToggleButton)(() => ({
  display: "flex",
  flexGrow: 1,
  flexDirection: "column",
  gap: "calc(var(--spacing)*2)",
  border: "none !important",
  textTransform: "none",
  color: "var(--color-text-primary) !important",
  fontWeight: "var(--font-weight-medium) !important",
  fontSize: "var(--text-base)",
  letterSpacing: "0.15px",
  lineHeight: "var(--text-base--line-height)",
  borderRadius: "var(--radius-lg) !important",
  margin: "0 !important",
  padding: "calc(var(--spacing)*1) calc(var(--spacing)*2) !important",
  [`&.${toggleButtonClasses.selected}`]: {
    backgroundColor: "var(--color-surface-base-light) !important",
  },
}));
